import i18n from '../../../i18n'
export type PricingModeOption = 'simple' | 'detailed' | 'free' | 'desuet'

export const PRICING_MODE_OPTIONS: {
  value: PricingModeOption
  label: string
  hint: string
}[] = [
  { value: 'simple', get label() { return i18n.t('organizations:locationFormPricingConstants.simplifie') }, get hint() { return i18n.t('organizations:locationFormPricingConstants.fourchette_partir_entre') } },
  { value: 'detailed', get label() { return i18n.t('organizations:locationFormPricingConstants.detaille') }, get hint() { return i18n.t('organizations:locationFormPricingConstants.grilles_s5_regles_s6') } },
  { value: 'free', get label() { return i18n.t('organizations:locationFormPricingConstants.gratuit') }, get hint() { return i18n.t('organizations:locationFormPricingConstants.refuge_lean_to_sans_frais') } },
  { value: 'desuet', get label() { return i18n.t('organizations:locationFormPricingConstants.desuet') }, get hint() { return i18n.t('organizations:locationFormPricingConstants.champs_legacy') } },
]
